import { REHYDRATE } from "redux-persist/constants"

import {
    AUTHENTICATION_LOGIN_RESPONSE,
    UNAUTHENTICATED
} from "../actions/action-types"
import ROUTES from "../config/routes"

export default (state = [], action) => {
    const { type, permissions } = action
    switch (type) {
        case REHYDRATE:
            const authentication = action.payload.authentication
            if (authentication && authentication.permissions)
                return getAvailableRoutes(ROUTES, authentication.permissions)
            else return state
        case AUTHENTICATION_LOGIN_RESPONSE:
            return getAvailableRoutes(ROUTES, permissions)
        case UNAUTHENTICATED:
            return []
        default:
            return state
    }
}

function getAvailableRoutes(allRoutes, permissions) {
    return allRoutes
        .map(
            route =>
                route.switch
                    ? {
                          ...route,
                          switch: getAvailableRoutes(route.switch, permissions)
                      }
                    : route
        )
        .filter(
            route =>
                // Allow switch routes to pass straight through as they have been processed recursively
                route.switch ||
                // Filter out routes where some permissions that are required are missing from the user's permissions
                !route.permissionsRequired.some(
                    permissionRequired =>
                        permissions.indexOf(permissionRequired) === -1
                )
        )
}
